/**
 * Icon button with a loading spinner state.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2026
 */
import IconButton, { IconButtonProps } from '@/components/Button/IconButton'
import { BiLoaderAlt } from 'react-icons/bi'
import './ProgressIconButton.css'

/** Props for {@link ProgressIconButton}. */
interface ProgressIconButtonProps extends IconButtonProps {
  /** When true, replaces the icon with a spinning loader. */
  isWaiting: boolean
  /** When true, show the label beside the progress icon when waiting. */
  isWaitingShowlabel?: boolean
}

/**
 * An icon button that shows a spinning progress icon when `isLoading` is true.
 */
const ProgressIconButton = (props: ProgressIconButtonProps) => {
  const { isWaiting, isWaitingShowlabel, className, icon, label, ...rest } =
    props

  const baseClassName = className
    ? `progress-icon-button ${className}`
    : 'progress-icon-button'

  return (
    <IconButton
      {...rest}
      className={isWaiting ? `${baseClassName} waiting-msg` : baseClassName}
      icon={isWaiting ? <BiLoaderAlt className="icon-animation-spin" /> : icon}
      label={!isWaiting || isWaitingShowlabel ? label : undefined}
    />
  )
}

export default ProgressIconButton
